import { NavLink } from 'react-router-dom';
import './style.css';

const ProjectsPreview = () => {
  return (
    <section className="section projects-preview">
      <div className="container">
        <div className="projects-preview__wrapper">
          <h1 className="title-1">Примеры выполненных проектов</h1>

          <div className="projects-preview__panel">
            <p className="projects-preview__text">
              Документация и BIM-модели, подготовленные по данным лазерного
              сканирования.
            </p>

            <NavLink to="/projects" className="btn projects-preview__btn">
              Смотреть проекты
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsPreview;
